import Icon from "./ui/icon";

type ActionButtonProps = {
  iconName: string;
  label: string;
  href?: string;
  target?: string;
  onClick?: () => void;
  className?: string;
};

export default function ActionButton({
  iconName,
  label,
  href,
  target,
  onClick,
  className,
}: ActionButtonProps) {
  return (
    <a
      href={href}
      target={target}
      onClick={onClick}
      className={[
        "inline-flex items-center justify-center gap-3 rounded-full bg-pink px-6 py-3 text-base font-bold text-white transition duration-300 ease-in-out hover:-translate-y-1 hover:scale-[1.02] hover:cursor-pointer",
        className ?? "",
      ].join(" ")}
    >
      <Icon src={iconName} size={22} alt="" />
      <span className="leading-none">{label}</span>
    </a>
  );
}